<div class="inner-content">
  <ion-toolbar color="primary">
    <ion-title id="modal-title" class="ion-text-center ion-no-padding ion-text-uppercase fs-pt-16">{{modalTitle}}</ion-title>
  </ion-toolbar>

  <div class="ion-padding" style="text-align: center">
    <ion-label class="fs-pt-16"><b>{{modalMessage}}</b></ion-label>
  </div>

  <div class="ion-padding">
    <ion-radio-group [value]="currentStudente" [formControl]="ctrlStudente">
      @for (figlio of opzioniFigli; track figlio) {
        <ion-item>
          <ion-radio [value]="figlio">{{figlio.nome + ' ' + figlio.cognome}}</ion-radio>
        </ion-item>
      }
    </ion-radio-group>
  </div>

  <ion-grid>
    <ion-row class="ion-justify-content-center ion-align-items-center">
      <ion-col size-sm="12" size-xl="6" size-md="8">
        <ion-button class="ion-margin-top ion-text-uppercase"
          [disabled]="ctrlStudente.invalid"
          color="primary" (click)="confirm()" fill="solid"
        expand="block">{{confirmButtonText | uppercase}}</ion-button>
        <ion-button class="ion-margin-top ion-text-uppercase"
          color="danger" (click)="cancel()" fill="solid"
        expand="block">{{cancelButtonText | uppercase}}</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
